export default __webpack_public_path__ + "static/media/menu_liquidity.e2cb92a2.svg";